import "/__w/1/s/BotFramework-WebChat/packages/component/src/decorator/private/BorderLoader.module_built.css";
const classes = {"border-loader__track":"w17q6fa_border-loader__track","border-loader__loader":"w17q6fa_border-loader__loader"}
export default classes

const _border_loader__track0 = classes["border-loader__track"]
export { _border_loader__track0 as "border-loader__track" }

const _border_loader__loader0 = classes["border-loader__loader"]
export { _border_loader__loader0 as "border-loader__loader" }
